import { ChainAsset, FiatCurrency, OrderAction, OrderStatus, PaymentMethod } from 'src/common/static'

export interface OrderModel {
  id: number
  status: OrderStatus
  createdAt: string
  fiatAmount: string
  fiatCurrency: FiatCurrency
  cryptoAmount: string
  txId?: string
}

export interface OrderDetails {
  id: number
  type: 'MINT' | 'BURN'
  fiatAmount: string
  fiatCurrency: FiatCurrency
  cryptoAmount: string
  fxRate: number
  status: OrderStatus
  paymentMethod: PaymentMethod
  createdAt: string
  transfers: {
    id: number
    amount: string
    fiatCurrency: FiatCurrency
    status: string
    referenceId: string
    createdAt: string
  }[]
  transactions: {
    id: number
    asset: string
    amount: string
    status: string
    address: string
    chain: string
    referenceId: string
    createdAt: string
  }[]
  organizationId?: string
}

export interface OrdersModel {
  numOfPages: number
  orders: OrderDetails[]
}

export enum KYC_STATUS {
  UNINITIATED = 'Uninitiated',
  NEW = 'New',
  PENDING = 'Pending',
  REVIEW = 'Review',
  ESCALATED = 'Escalated',
  APPROVED = 'Approved',
  REJECTED = 'Rejected'
}

export interface EligibilityModel {
  walletScreening: 'fail' | 'success'
  kycStatus: KYC_STATUS
}

export interface ExchangeRatesModel {
  eth: number
  usd: number
}

export interface GraphOrderModel {
  type: OrderAction
  cryptoAmount: string
  asset: ChainAsset
  createdAt: string
}

export interface GraphModel {
  accountCreation: string
  orders: GraphOrderModel[]
}

export interface FxRateObservation {
  d: string
  FXUSDCAD: {
    v: string
  }
}

export interface OrderLimitsModel {
  dailyBankingLimit: number
  weeklyBankingLimit: number
}
